import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PythonTema1 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/Tema1_Introduccion.pdf`;
  /*const pdfUrl = "/pdf/Tema1_Introduccion.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Tema 1: Introducción</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Tema 1: Introducción" />
      </Container>
    </>
  );
};

 export default PythonTema1;
